import { IconProps } from './IconProps'

export function GooglePlayIcon(props: IconProps): JSX.Element {
  const width = props.width ?? 136
  const height = props.height ?? 40
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox='0 0 136 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Badges' clipPath='url(#clip0_9064_130140)'>
        <path
          id='Vector'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M130.662 40H5.6659C2.90918 40 0.664062 37.7456 0.664062 35V5C0.664062 2.24439 2.90918 0 5.6659 0H130.662C133.416 0 135.664 2.24439 135.664 5V35C135.664 37.7456 133.416 40 130.662 40Z'
          fill='black'
        />
        <path
          id='Vector_2'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M130.662 0.800499C132.974 0.800499 134.867 2.68828 134.867 5V35C134.867 37.3117 132.987 39.1995 130.662 39.1995H5.6659C3.35373 39.1995 1.46128 37.3117 1.46128 35V5C1.46128 2.68828 3.34131 0.800499 5.6659 0.800499H130.662ZM130.662 0H5.6659C2.90918 0 0.664062 2.25436 0.664062 5V35C0.664062 37.7556 2.90918 40 5.6659 40H130.662C133.416 40 135.664 37.7556 135.664 35V5C135.664 2.25436 133.416 0 130.662 0Z'
          fill='#848484'
        />
        <path
          id='Vector_3'
          d='M71.7832 13.232C70.8817 13.232 70.1217 12.9153 69.5207 12.2918C68.9247 11.6858 68.5919 10.8504 68.6068 9.99755C68.6068 9.08732 68.9147 8.31675 69.5207 7.70577C70.1192 7.08233 70.8792 6.76562 71.7807 6.76562C72.6723 6.76562 73.4323 7.08233 74.0432 7.70577C74.6492 8.3367 74.9571 9.10727 74.9571 9.99755C74.9472 10.9103 74.6393 11.6808 74.0432 12.2893C73.4447 12.9177 72.6847 13.232 71.7832 13.232ZM44.9587 13.232C44.0771 13.232 43.3121 12.9202 42.6863 12.3043C42.0654 11.6908 41.75 10.9153 41.75 10C41.75 9.08483 42.0654 8.30927 42.6863 7.6958C43.2997 7.07984 44.0646 6.76812 44.9587 6.76812C45.3958 6.76812 45.8205 6.8554 46.2278 7.03246C46.6276 7.20453 46.953 7.43894 47.1939 7.72572L47.2535 7.79804L46.5804 8.46139L46.5109 8.37909C46.1309 7.92523 45.6218 7.70328 44.9488 7.70328C44.3478 7.70328 43.8237 7.91774 43.3916 8.34169C42.957 8.76812 42.736 9.32672 42.736 10.0025C42.736 10.6783 42.957 11.2369 43.3916 11.6634C43.8237 12.0873 44.3478 12.3018 44.9488 12.3018C45.5895 12.3018 46.1284 12.0873 46.5482 11.6634C46.7965 11.414 46.9505 11.0649 47.0051 10.6235H44.8469V9.69081H47.9315L47.9439 9.7756C47.9662 9.93271 47.9886 10.0948 47.9886 10.2444C47.9886 11.1048 47.7303 11.8005 47.2187 12.3143C46.6376 12.9227 45.8776 13.232 44.9587 13.232ZM80.6245 13.0998H79.6733L76.7602 8.41899L76.785 9.26188V13.0973H75.8338V6.90029H76.9191L76.9489 6.94767L79.6882 11.3566L79.6634 10.5162V6.90029H80.6245V13.0998ZM64.6356 13.0998H63.672V7.83296H62.0006V6.90029H66.3046V7.83296H64.6332V13.0998H64.6356ZM61.2158 13.0998H60.2547V6.90029H61.2158V13.0998ZM55.8142 13.0998H54.853V7.83296H53.1816V6.90029H57.4856V7.83296H55.8142V13.0998ZM52.5732 13.0898H48.8876V6.90029H52.5732V7.83296H49.8512V9.5337H52.3074V10.4564H49.8512V12.1571H52.5732V13.0898ZM70.226 11.6509C70.6557 12.0823 71.1772 12.2993 71.7832 12.2993C72.4066 12.2993 72.9157 12.0873 73.3404 11.6509C73.7626 11.227 73.9762 10.6709 73.9762 10C73.9762 9.32922 73.7626 8.77061 73.3429 8.34917C72.9132 7.91774 72.3892 7.70079 71.7857 7.70079C71.1623 7.70079 70.6532 7.91276 70.231 8.34917C69.8088 8.77311 69.5952 9.32922 69.5952 10C69.5952 10.6709 69.8063 11.2295 70.226 11.6509Z'
          fill='white'
        />
        <path
          id='Vector_4'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M68.5169 21.7544C66.1699 21.7544 64.2675 23.5425 64.2675 26.0088C64.2675 28.4527 66.1824 30.2632 68.5169 30.2632C70.8638 30.2632 72.7662 28.4627 72.7662 26.0088C72.7662 23.5425 70.8638 21.7544 68.5169 21.7544ZM68.5169 28.5774C67.2329 28.5774 66.1277 27.5101 66.1277 25.9988C66.1277 24.4652 67.2354 23.4203 68.5169 23.4203C69.8009 23.4203 70.906 24.4652 70.906 25.9988C70.9085 27.52 69.8009 28.5774 68.5169 28.5774ZM59.2458 21.7544C56.8989 21.7544 54.9965 23.5425 54.9965 26.0088C54.9965 28.4527 56.9113 30.2632 59.2458 30.2632C61.5928 30.2632 63.4952 28.4627 63.4952 26.0088C63.4952 23.5425 61.5903 21.7544 59.2458 21.7544ZM59.2458 28.5774C57.9618 28.5774 56.8567 27.5101 56.8567 25.9988C56.8567 24.4652 57.9643 23.4203 59.2458 23.4203C60.5298 23.4203 61.635 24.4652 61.635 25.9988C61.635 27.52 60.5298 28.5774 59.2458 28.5774ZM48.2139 23.0537V24.8542H52.5179C52.3863 25.8642 52.0535 26.6098 51.5444 27.121C50.9136 27.7544 49.94 28.4427 48.2239 28.4427C45.5789 28.4427 43.5101 26.2981 43.5101 23.6422C43.5101 20.9864 45.5789 18.8417 48.2239 18.8417C49.6519 18.8417 50.6925 19.4078 51.4649 20.131L52.7365 18.8542C51.6636 17.8218 50.2355 17.0312 48.2338 17.0312C44.6054 17.0312 41.5605 19.9988 41.5605 23.6322C41.5605 27.2756 44.6029 30.2332 48.2338 30.2332C50.1933 30.2332 51.6636 29.5899 52.8259 28.3779C54.0105 27.1884 54.3855 25.5101 54.3855 24.1559C54.3855 23.7345 54.3533 23.3554 54.2862 23.0337H48.2115C48.2139 23.0312 48.2139 23.0537 48.2139 23.0537ZM93.3374 24.4552C92.9822 23.5001 91.9093 21.7445 89.7089 21.7445C87.5284 21.7445 85.7154 23.4677 85.7154 25.9988C85.7154 28.3879 87.5085 30.2532 89.92 30.2532C91.8572 30.2532 92.9847 29.0637 93.4491 28.3654L92.0112 27.3978C91.5343 28.1086 90.8712 28.5749 89.9299 28.5749C88.9787 28.5749 88.3132 28.141 87.8711 27.2856L93.536 24.929C93.536 24.9315 93.3374 24.4552 93.3374 24.4552ZM87.5606 25.8766C87.5159 24.2332 88.8322 23.3978 89.7735 23.3978C90.5161 23.3978 91.1345 23.7644 91.3456 24.2981L87.5606 25.8766ZM82.9587 29.9988H84.8188V17.5001H82.9587V29.9988ZM79.9039 22.6996H79.8368C79.4171 22.1983 78.6199 21.7445 77.6017 21.7445C75.4882 21.7445 73.5411 23.6123 73.5411 26.0113C73.5411 28.4003 75.4782 30.2457 77.6017 30.2457C78.6075 30.2457 79.4171 29.7894 79.8368 29.2781H79.9039V29.8891C79.9039 31.5125 79.0396 32.3879 77.6464 32.3879C76.5064 32.3879 75.7986 31.5649 75.5105 30.8766L73.8937 31.5549C74.3582 32.6771 75.5974 34.0662 77.6439 34.0662C79.8244 34.0662 81.6722 32.7769 81.6722 29.6322V21.9988H79.9138V22.6996C79.9163 22.6996 79.9039 22.6996 79.9039 22.6996ZM77.7681 28.5774C76.4841 28.5774 75.4112 27.5001 75.4112 26.0113C75.4112 24.5101 76.4841 23.4228 77.7681 23.4228C79.0396 23.4228 80.0256 24.5225 80.0256 26.0113C80.038 27.5001 79.0421 28.5774 77.7681 28.5774ZM102.047 17.5001H97.5991V29.9988H99.4593V25.2657H102.05C104.108 25.2657 106.133 23.7669 106.133 21.3879C106.133 19.0088 104.116 17.5001 102.047 17.5001ZM102.102 23.52H99.4568V19.2308H102.102C103.495 19.2308 104.282 20.3854 104.282 21.3754C104.282 22.3554 103.485 23.52 102.102 23.52ZM113.588 21.732C112.237 21.732 110.844 22.333 110.268 23.6422L111.917 24.3305C112.272 23.6422 112.923 23.4078 113.61 23.4078C114.574 23.4078 115.548 23.9864 115.57 25.0188V25.1509C115.237 24.9614 114.507 24.6721 113.633 24.6721C111.852 24.6721 110.047 25.6497 110.047 27.4826C110.047 29.1609 111.507 30.2382 113.134 30.2382C114.383 30.2382 115.071 29.6721 115.5 29.0163H115.568V29.9839H117.361V25.1958C117.361 22.9664 115.712 21.732 113.588 21.732ZM113.355 28.5774C112.746 28.5774 111.894 28.2781 111.894 27.5101C111.894 26.5425 112.957 26.1759 113.864 26.1759C114.683 26.1759 115.071 26.3529 115.558 26.5973C115.423 27.7195 114.48 28.5674 113.355 28.5774ZM123.902 21.9988L121.766 27.4203H121.699L119.487 21.9988H117.485L120.805 29.5774L118.913 33.7894H120.85L125.959 21.9988H123.902ZM107.158 29.9988H109.018V17.5001H107.158V29.9988Z'
          fill='white'
        />
        <path
          id='Vector_5'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.056 7.53218C10.768 7.8439 10.6016 8.32021 10.6016 8.94365V31.0559C10.6016 31.6793 10.768 32.1556 11.066 32.4549L11.143 32.5222L23.4812 20.1332V19.8564L11.133 7.46484L11.056 7.53218Z'
          fill='url(#paint0_linear_9064_130140)'
        />
        <path
          id='Vector_6'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M27.5859 24.2763L23.4707 20.1441V19.8548L27.5859 15.7227L27.6754 15.7775L32.5431 18.5556C33.9364 19.3436 33.9364 20.6454 32.5431 21.4434L27.6754 24.2214L27.5859 24.2763Z'
          fill='url(#paint1_linear_9064_130140)'
        />
        <path
          id='Vector_7'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M27.6745 24.2219L23.4699 20L11.0547 32.4663C11.5092 32.9551 12.2716 33.01 13.1235 32.5337L27.6745 24.2219Z'
          fill='url(#paint2_linear_9064_130140)'
        />
        <path
          id='Vector_8'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M27.6745 15.7784L13.1235 7.47918C12.2716 6.9904 11.5067 7.05774 11.0547 7.54651L23.4699 20.0004L27.6745 15.7784Z'
          fill='url(#paint3_linear_9064_130140)'
        />
        <path
          id='Vector_9'
          opacity='0.2'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M27.585 24.1328L13.1332 32.3772C12.3261 32.8435 11.6059 32.8111 11.1414 32.3871L11.0645 32.4645L11.1414 32.5318C11.6059 32.9532 12.3261 32.9881 13.1332 32.5218L27.6844 24.2226L27.585 24.1328Z'
          fill='black'
        />
        <path
          id='Vector_10'
          opacity='0.12'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M32.5418 21.2993L27.5723 24.1322L27.6617 24.2219L32.5294 21.4439C33.2273 21.0449 33.57 20.5212 33.57 20C33.5278 20.4788 33.1726 20.9327 32.5418 21.2993Z'
          fill='black'
        />
        <path
          id='Vector_11'
          opacity='0.25'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.1248 7.62427L32.5436 18.7016C33.1744 19.0582 33.5296 19.5245 33.5842 20.0008C33.5842 19.4796 33.2415 18.9559 32.5436 18.5569L13.1248 7.47963C11.7316 6.67913 10.6016 7.34746 10.6016 8.94597V9.0906C10.6016 7.48961 11.7316 6.83375 13.1248 7.62427Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_9064_130140'
          x1='22.3745'
          y1='8.70508'
          x2='2.60006'
          y2='13.9524'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00A0FF' />
          <stop offset='0.00657' stopColor='#00A1FF' />
          <stop offset='0.2601' stopColor='#00BEFF' />
          <stop offset='0.5122' stopColor='#00D2FF' />
          <stop offset='0.7604' stopColor='#00DFFF' />
          <stop offset='1' stopColor='#00E3FF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_9064_130140'
          x1='34.3601'
          y1='19.9995'
          x2='10.2623'
          y2='19.9995'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE000' />
          <stop offset='0.4087' stopColor='#FFBD00' />
          <stop offset='0.7754' stopColor='#FFA500' />
          <stop offset='1' stopColor='#FF9C00' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_9064_130140'
          x1='25.3882'
          y1='22.2973'
          x2='9.42542'
          y2='49.0538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF3A44' />
          <stop offset='1' stopColor='#C31162' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_9064_130140'
          x1='7.92841'
          y1='0.179171'
          x2='15.0501'
          y2='12.1291'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#32A071' />
          <stop offset='0.0685' stopColor='#2DA771' />
          <stop offset='0.4762' stopColor='#15CF74' />
          <stop offset='0.8009' stopColor='#06E775' />
          <stop offset='1' stopColor='#00F076' />
        </linearGradient>
        <clipPath id='clip0_9064_130140'>
          <rect width='136' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
